(() => {
  let queue = Promise.resolve();
  let revision = 0;
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-cart-note]');
    if (!input) return;
    const note = input.value;
    const currentRevision = ++revision;
    const status = input.closest('.cart-note').querySelector('[role="status"]');
    document.querySelectorAll('[data-cart-note]').forEach(field => { field.value = note; });
    status.textContent = 'Saving...';
    queue = queue.catch(() => {}).then(async () => {
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({note})
        });
        if (!response.ok) throw new Error('Save failed');
        if (currentRevision === revision) status.textContent = 'Saved';
      } catch {
        if (currentRevision === revision) status.textContent = 'Could not save your note. Please try again.';
      }
    });
  });
})();
